import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IndexQuery } from '../../types/graphql-types';
import EmbeddedTour from '../components/EmbeddedTour';
import GetStarted from '../components/GetStarted';
import HeroSlider from '../components/HeroSlider';
import Layout from '../components/Layout';
import LearnMore from '../components/LearnMore';
import Logos from '../components/Logos';
import SpecialOffer from '../components/SpecialOffer';
import Steps from '../components/Steps';
import WhyR360Tours from '../components/WhyR360Tours';
import { useTransformNode } from '../hooks/useTransformer';

const INDEX_QUERY = graphql`
  query Index {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "index-page" } } }
    ) {
      edges {
        node {
          id
          fields {
            language
            country
          }
          frontmatter {
            templateKey
            hasSpecialOffer
          }
        }
      }
    }
  }
`;

const IndexPage: React.FC = () => {
  const data = useStaticQuery<IndexQuery>(INDEX_QUERY);
  const { frontmatter } = useTransformNode(data);
  const hasSpecialOffer = frontmatter?.hasSpecialOffer;
  return (
    <Layout>
      <HeroSlider />
      <LearnMore />
      <Logos />
      <EmbeddedTour />
      <Steps />
      <GetStarted />
      <WhyR360Tours />
      {hasSpecialOffer && (
        <SpecialOffer promotionalPage="gen" isPromotionalPage={false} />
      )}
    </Layout>
  );
};

export default IndexPage;
